
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8256_461297)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#545C69"}},[_c('path',{attrs:{"d":"M9.112.032a1.5 1.5 0 011.23.394l.011.01 3.21 3.21.011.012a1.5 1.5 0 01-.308 2.306L10.17 7.96l-1.016 4.254a1.11 1.11 0 01-1.838.528L1.16 6.577a1.1 1.1 0 01.532-1.833l.01-.002 4.294-.957L8.039.73A1.5 1.5 0 019.112.032zm.355 1.01a.5.5 0 00-.591.236l-2.16 3.23a.5.5 0 01-.307.21l-4.484.999a.1.1 0 00-.047.164l6.133 6.143a.11.11 0 00.174-.056l1.059-4.434a.5.5 0 01.215-.304l3.282-2.118a.5.5 0 00.109-.765L9.653 1.15a.5.5 0 00-.186-.108z"}}),_c('path',{attrs:{"d":"M4.942 9.025a.5.5 0 01.003.707l-4.09 4.12a.5.5 0 01-.71-.704l4.09-4.12a.5.5 0 01.707-.003z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8256_461297"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    